<template>
    <coupon-redeem-form-base>
        <template slot-scope="{ redeemCoupon, code, updateCode, errors }">

            <article class="cart-coupon">
                <div
                    v-if="errors"
                    class="alert alert-danger"
                >
                    <span
                        v-for="(error, index) in errors[0]"
                        :key="index"
                    >
                        {{ error }}
                    </span>
                </div>
                <label for="discount">{{ __('Kuponkód') }} / {{ __('GIFT CARD kód')}}</label>
                <input
                    id="discount"
                    name="code"
                    :value="code"
                    type="text"
                    required
                    @input="updateCode"
                    class="px-3 py-2 text-sm w-60 leading-tight text-gray-700 border rounded shadow appearance-none focus:outline-none focus:shadow-outline"
                >
                <button class="ml-5 p-1 btn-next cart-continue" @click="$loading.show(); redeemCoupon(code)">
                    {{ __('Beváltás') }}
                </button>
            </article>
        </template>
    </coupon-redeem-form-base>
</template>

<script>
export default {
    name: 'CouponRedeemForm'
}
</script>
